import { LocationConfig as BaseLocationConfig } from '../../core';

export class LocationConfig extends BaseLocationConfig {}
